import { render } from "./textaAreaWithCountdown.vue?vue&type=template&id=a9f7f68e&scoped=true"
import script from "./textaAreaWithCountdown.vue?vue&type=script&lang=js"
export * from "./textaAreaWithCountdown.vue?vue&type=script&lang=js"

import "./textaAreaWithCountdown.vue?vue&type=style&index=0&id=a9f7f68e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9f7f68e"

export default script